define([
	"dojo/store/util/SimpleQueryEngine",
	"./common",
	"csi",
	"csi/_base/underscore",
], function(SimpleQueryEngine, {DISABLED_PROPERTY, IS_GROUP_PROPERTY}, csi, _) {

	// Adds supports for grouping settings in query options; all functions take the group object as a parameter to use to
	// store temporal data that it may need to do the sorting/naming.
	//
	// 	queryOptions.group = {
	//		id: function(item, group) returning group id, or if string, then interpreted as property of item to use to get group id
	// 		nameFunc: function(id, group) returning name for group; if not specified, then same as id
	// 		sortFunc: function(id, group) returning ranking to sort groups; if not specified then same id is used to sort. Set to null if items (and groups) are ordered.
	// 		isSuggestedFunc: function(id) returning whether a group is a Suggested one.
	//	}
	//
	// NOTE: Be aware that paging is not supported when grouping by section due to the way the Dojo _SearchMixin works. See _ComboBox for where that is enforced.
	// NOTE: This code is copied to CheckedMultiselectDropdown.js -> groupItems(storeOptions, items). Update code there if you change grouping code in this module or Names.js

	return function(query, options) {
		// summary: use SimpleQueryEngine to query for results, but group them before returning
		const sqe = SimpleQueryEngine(query, options);
		const store = options?.store;
		const cssProperty = options?.cssProperty || store?.cssProperty || null;
		const idProperty = store?.idProperty || "id";
		const labelProperty = store?.labelProperty || "name";
		const searchProperty = store?.searchProperty || "search";
		const group = options?.group;
		const groupNameFunc = group?.nameFunc;
		const groupIsSuggestedFunc = group?.isSuggestedFunc;
		const groupSortFunc = group?.sortFunc;

		// if "group" specified, then use id provided (if any), rather than default to "group" either way;
		// this is important to allow for options = {group:{}} which can be used to skip grouping if no groupId
		const groupId = group ? group.id : "group";
		let groupIdFunc;

		// do not apply grouping if querying for a specific result (such as from "get" function)
		if (!query || (query[idProperty] == null)) {
			if (_.isString(groupId)) {
				groupIdFunc = function(item) {
					const value = item[groupId];
					return (value == null) ? "" : value;
				};
			} else if (groupId) {
				groupIdFunc = function(item) {
					const value = groupId(item, group);
					return (value == null) ? "" : value;
				};
			}
		}

		function execute(array) {
			// first, get results according to SimpleQueryEngine
			let results = sqe(array, query);

			if (groupIdFunc) {
				// map items into groups
				const groups = csi.hashArray(results, groupIdFunc, null, null, true);
				let ids = _.keys(groups);

				// sort groups by name
				if (groupSortFunc) {
					ids = csi.sort(ids, (id) => groupSortFunc(id, group));
				} else if (!group || (group.sortFunc === undefined)) {
					ids = ids.sort();
				}

				// compose list of results by group
				const {total} = results;

				results = [];

				_.each(ids, function(id) {
					// if empty group name, then just show results
					if (id) {
						const label = groupNameFunc?.(id, group) ?? id;
						const obj = {
							[idProperty]: id,
							[labelProperty]: label,
							[searchProperty]: label,
							[DISABLED_PROPERTY]: true,
							[IS_GROUP_PROPERTY]: true,
						};

						if (cssProperty) {
							const suggestedCss = (groupIsSuggestedFunc?.(id, group)) ? " csi-grouped-selection-suggested" : "";
							obj[cssProperty] = `csi-grouped-selection${suggestedCss}`;
						}

						results.push(obj);
					}

					results = results.concat(groups[id]);
				});

				results.total = total;
			}

			return results;
		}

		execute.matches = sqe.matches;
		return execute;
	};
});
